import { render, staticRenderFns } from "./FotoTexto.vue?vue&type=template&id=5a6b76ea&scoped=true&"
import script from "./FotoTexto.vue?vue&type=script&lang=js&"
export * from "./FotoTexto.vue?vue&type=script&lang=js&"
import style0 from "./FotoTexto.vue?vue&type=style&index=0&id=5a6b76ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b76ea",
  null
  
)

export default component.exports